
import "./Sobre.css"

import check2 from "../../../../imagens/check2-icon.svg"
import { CiCircleQuestion } from "react-icons/ci"

import { Drawer, Collapse, Tooltip } from 'antd';
import { useState } from "react"

import iconTime from "../../../../imagens/time-icon2.svg"
import iconGen from "../../../../imagens/gem-icon.svg"
import iconShield from "../../../../imagens/shield-icon.svg"

export function SobreEmpresa({ component3Ref, isVisible }) {

    const [open, setOpen] = useState(false);
    const items = [
        {
            key: '1',
            label: 'Eu não entendo nada de contabilidade. Serve pra mim?',
            children: <p>Serve. O ZAP MEI foi feito pra quem quer resolver sem aprender burocracia.</p>,
        },
        {
            key: '2',
            label: 'Vou ter que usar plataforma?',
            children: <p>Não. A lógica é: WhatsApp. Sem painel complicado.</p>,
        },
        {
            key: '3',
            label: 'E se eu tiver uma dúvida mais complexa?',
            children: <p>Aí entra o diferencial: resposta com especialista quando necessário.</p>,
        },
        {
            key: '4',
            label: 'Isso ajuda a não estourar o limite do MEI?',
            children: <p>Sim: você tem orientação e acompanhamento pra não ser pego de surpresa.</p>,
        },
    ];


    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };

    const onChange = key => {
        console.log(key);
    };

    return (
        <>
            <div>
                <div ref={component3Ref} className={`container-principal ${isVisible ? "show" : ""}`}>

                    <div className="content-wrapper">
                        {/* Lado Esquerdo: Textos e Botão */}
                        <div className="text-section">
                            <h1>A diferença aqui é simples: velocidade no <strong style={{ color: "#5fb75f" }}>WhatsApp</strong> com <br />segurança para o seu negócio!</h1>
                            <p>
                                O <strong style={{ color: "#5fb75f" }}>ZAP MEI</strong> é do <strong style={{ color: "#004a8e" }}>Meu Contador Online</strong>, contadores há 60 anos, com +15.000 empresas
                                atendidas e presença em +1.000 municípios.
                            </p>
                            {/*<a href="https://www.meucontadoronline.com.br/" className="btn-site" target="_blank"
                                rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                Visita nosso Site
                            </a>*/}
                        </div>

               

                        {/* Lado Direito: Grid de Cards */}
                        <div className="cards-grid">
                            <div className="card">
                                <div className="icon-circle"><img src={iconTime} alt="experiência" /></div>
                                <p>
                                    <label style={{ fontWeight: 300 }}>Experiência
                                        de</label> <br /><strong>60 anos</strong>
                                </p>
                            </div>
                            <div className="card">
                                <div className="icon-circle"><img src={iconGen} alt="exclusivo" /></div>
                                <p>
                                    <label style={{ fontWeight: 300 }}>Contador</label> <br /><strong>exclusivo</strong>
                                </p>
                            </div>
                            <div className="card">
                                <div className="icon-circle"><img src={iconShield} alt="segurança" /></div>
                                <p>
                                    <strong>Segurança</strong> <br /><label style={{ fontWeight: 300 }}>para o seu negócio</label>
                                </p>
                            </div>
                            <div className="card">
                                <div className="icon-circle">
                                    <img src={check2} alt="plataforma" />
                                </div>

                                <p>
                                    <strong>Satisfação</strong> <br /><label style={{ fontWeight: 300 }}>garantia</label>
                                </p>
                            </div>
                        </div>
                    </div>



                    <div class="card-cta">
                        <div class="badge-pop">ACESSE AGORA</div>

                        <p class="cta-text">
                            Contador exclusivo por R$ 1,70 por dia<br />
                            <p>
                                <strong style={{ color: "#5fb75f" }}>
                                Tudo o que seu MEI precisa por apenas R$ 49,90/mês. Sem taxas escondidas.
                            </strong>
                            </p>
                        </p>

                        {/*<div class="price-container">
                            <span class="currency">R$</span>
                            <span class="amount">49,90</span>
                            <span class="period">/MÊS</span>
                        </div>*/}

                        <div style={{ display: "flex" }}>
                            <a href="https://wa.me/5508000420627?text=Ol%C3%A1!%20Quero%20assinar%20o%20ZAP%20MEI%20e%20focar%20no%20meu%20neg%C3%B3cio!"
                                target="_blank"
                                rel="noopener noreferrer"
                                id="btn-whatsapp-zapmei"
                                class="btn-whatsapp"
                                style={{ textDecoration: 'none' }}>
                                LIBERAR MEU ACESSO!
                            </a>
                        </div>
                    </div>


                    <Tooltip title="Perguntas Frequentes" color="#004a8e" placement="left">
                       <div className="btn-faq" onClick={showDrawer}>
                        <CiCircleQuestion />
                    </div>
                    </Tooltip>

                    <Drawer
                        title="Perguntas Frequentes"
                        closable={{ 'aria-label': 'Close Button' }}
                        onClose={onClose}
                        open={open}
                    >
                        <Collapse items={items} defaultActiveKey={['1']} onChange={onChange} />
                    </Drawer>

                </div>
            </div>
        </>
    );
}